import { Button } from "components/atoms/Button";

interface FiltersSidebarFooterProps {
    onClickApply: () => void;
    onClickCancel: () => void;
    onClickClearAll: () => void;
    localFilters: Filters;
    isLoading?: boolean;
}

function FiltersSidebarFooter({
    onClickApply,
    onClickCancel,
    onClickClearAll,
    localFilters,
    isLoading,
}: FiltersSidebarFooterProps) {
    return (
        <div className="filters-sidebar__footer">
            <div className="filters-sidebar__footer__buttons">
                <Button
                    type="primary"
                    onClick={onClickApply}
                    id="reports-apply-filters-button"
                    data-ph-capture-attribute-filters={JSON.stringify(localFilters)}
                    disabled={isLoading}
                >
                    {!isLoading ? "Apply" : "Loading..."}
                </Button>
                <Button onClick={onClickCancel} type="link" id="reports-cancel-filters-button" disabled={isLoading}>
                    Cancel
                </Button>
            </div>
            <Button onClick={onClickClearAll} type="link" id="reports-reset-filters-button" disabled={isLoading}>
                Reset filters
            </Button>
        </div>
    );
}

export default FiltersSidebarFooter;
